import React from "react";
import { useNavigate } from "react-router-dom";

export const DailyStatCard = ({ dailyStats, children }) => {
  const userId = dailyStats?.user_id;
  const totalClosedTickets = dailyStats?.total_closed_tickets_count;
  const totalResolvedTickets = dailyStats?.total_resolved_tickets_count;
  const totalTickets = dailyStats?.total_tickets_count;
  const totalActiveTickets = totalTickets - totalClosedTickets - totalResolvedTickets;

  const stats = [
    { title: "Aktif", value: totalActiveTickets || 0, color: "bg-blue-500" },
    { title: "Çözülen", value: totalResolvedTickets || 0, color: "bg-emerald-500" },
    { title: "Kapatılan", value: totalClosedTickets || 0, color: "bg-rose-500" },
  ];

  const navigator = useNavigate();

  return (
    <div className="relative group inline-block">
      <div tabIndex={0} className="cursor-pointer transition-transform duration-100 group-hover:scale-110">
        {children}
      </div>

      <div
        tabIndex={0}
        className="absolute left-full top-0 ml-1.5 z-[100] 
        w-[300px] pointer-events-none
        opacity-0 scale-95 translate-x-[-10px]
        dropdown-content p-1 rounded-2xl dark:bg-base-100/40 bg-base-100/80 backdrop-blur-sm border border-white/10 shadow-2xl animate-in fade-in slide-in-from-left-2 
        group-hover:opacity-100 group-hover:scale-100 group-hover:translate-x-0 group-hover:pointer-events-auto
        transition-all dark:text-base text-white ease-out"
      >
        <h3 className="text-[10px] font-medium opacity-40 uppercase tracking-widest text-white my-2 ml-2.5">
          Günlük İstatistikler
        </h3>
        <div className="h-[2px] mx-2 bg-gradient-to-r from-blue-500 via-emerald-500 to-rose-500 opacity-20 rounded-full"></div>

        <div className="p-2 flex items-center justify-between divide-x divide-white/5">
          {stats.map((stat) => (
            <div
              key={stat.title}
              className="flex-1 flex flex-col items-center justify-center py-1 hover:bg-white/5 transition-colors duration-200 first:rounded-l-xl last:rounded-r-xl"
            >
              <div className="flex items-center gap-1.5 mb-0.5">
                <div className={`w-1.5 h-1.5 rounded-full ${stat.color} shadow-[0_0_8px_rgba(0,0,0,0.4)]`}></div>
                <span className="text-[10px] font-medium opacity-50 uppercase tracking-tighter">
                  {stat.title}
                </span>
              </div>
              <span className="text-base font-black text-white tabular-nums">
                {stat.value}
              </span>
            </div>
          ))}
        </div>
        <div className="flex justify-between items-end">
          <span className="text-sm mb-0.5 mx-1 self-end text-end items-end flex h-min text-white">Toplam Talep: {totalTickets || 0}</span>
          <button className="mx-1 btn btn-xs mb-0.5 btn-info text-white" onClick={() => navigator(`/admin/users/${userId}`)}>Detayları Gör</button>
        </div>
      </div>
    </div>
  );
};